const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/** Builds the TypeBox schema fragment for the DropDownWithFilter form element. */
function asDataDictionary(hNode, context) {
    const {
        id,
        title,
        foreignNamespace,
        foreignRelation,
        dropdownDisplayProperties,
        inputDisplayProperties,
        propertyOverride,
        required
    } = hNode;
    //This block tells us the foreign namespaces/relations should exist
    //and the filters will tell us about properties we'd expect to be on there
    let [_subDataDictionary = {}, _partialTypeDefinition = {}] = (hNode.children || []).reduce(
        ([sdd, ptd], child) => {
            // Extract schema from each child block
            const [_subDataDictionary = {}, _partialTypeDefinition = {}] = context.extractFromChild(child, context);
            // merge combines objects, accumulating child schemas
            return [
                merge(sdd, _subDataDictionary),
                moduleRegistration.mergePartialTypeDefinitions(ptd, _partialTypeDefinition, context)
            ];
        },
        [{}, {}]
    );

    // Preserve discovery of foreign namespace/relation in the traversal result so that
    // downstream assembly can see this relation exists. We no longer embed legacy _meta.
    const subDataDictionary = merge(
        {
            [foreignNamespace]: {
                [foreignRelation]: {
                    ..._partialTypeDefinition
                }
            }
        },
        _subDataDictionary
    );

    // reuse consistent flags
    const { isRequired, isEditable, isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(
        required,
        context
    );
    //this block tells us about this current property
    // specs contains metadata for UI hints and validation behavior
    const specs = {
        id,
        title,
        required: isRequired,
        editable: isEditable,
        optional: isOptional
    };
    const properties = [...new Set([...dropdownDisplayProperties, ...inputDisplayProperties])];
    const partialTypeDefinition = context.registerForeignKey(foreignNamespace, foreignRelation, properties, specs);
    const foreignKeyPropertyName = `${foreignNamespace}:${foreignRelation}`;
    // Filters and menu options still query the foreign relation. propertyOverride only renames the
    // saved field so the primary record keeps a domain-specific shape.
    const key = propertyOverride || foreignKeyPropertyName;
    if (propertyOverride && partialTypeDefinition[foreignKeyPropertyName]) {
        partialTypeDefinition[key] = partialTypeDefinition[foreignKeyPropertyName];
        delete partialTypeDefinition[foreignKeyPropertyName];
        partialTypeDefinition[key]['x-propertyName'] = key;
    }
    // Attach UI hints as custom extensions (x-*) to the generated schema
    // These extensions provide metadata for form generation and validation
    if (partialTypeDefinition[key]) {
        const schema = partialTypeDefinition[key];
        schema['x-dropdownDisplayProperties'] = dropdownDisplayProperties;
        schema['x-inputDisplayProperties'] = inputDisplayProperties;
        Object.assign(schema, schemaOptions);
    }

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
